import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/vercel/path1/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "faq"
    }}>{`FAQ`}</h1>
    <h2 {...{
      "id": "how-to-update-theme"
    }}>{`How to update theme?`}</h2>
    <p>{`We add an automatic system to push the update to your website. You'll get a notification on your site when your theme is outdated, and from that notification or update dashboard, you can update your theme.`}</p>
    <h2 {...{
      "id": "how-to-use-child-theme"
    }}>{`How to use child theme?`}</h2>
    <p>{`In the theme package you should get a file named `}<inlineCode parentName="p">{`cartsy-child.zip`}</inlineCode>{` . Upload this zip as theme and activate it. Make sure you have already Cartsy installed.
Both child and main theme must have to be installed but child theme have to be activated.`}</p>
    <h2 {...{
      "id": "how-to-optimize-my-site"
    }}>{`How to optimize my site?`}</h2>
    <p>{`To optimize your site you can use below two free plugin. You can also configure CDN and for object caching you can also use `}<inlineCode parentName="p">{`Redis`}</inlineCode>{` if your server support it.`}</p>
    <ul>
      <li parentName="ul">
        <p parentName="li"><a parentName="p" {...{
            "href": "https://wordpress.org/plugins/wp-super-cache/"
          }}>{`https://wordpress.org/plugins/wp-super-cache/`}</a></p>
      </li>
      <li parentName="ul">
        <p parentName="li"><a parentName="p" {...{
            "href": "https://wordpress.org/plugins/autoptimize/"
          }}>{`https://wordpress.org/plugins/autoptimize/`}</a></p>
      </li>
    </ul>
    <p>{`You can use any other caching plugin.`}</p>
    <h2 {...{
      "id": "after-deactivating-and-reactivating-the-theme-my-site-is-broken-nothing-is-showing-properly-how-to-fix"
    }}>{`After deactivating and reactivating the theme my site is broken nothing is showing properly. How to fix?`}</h2>
    <p>{`make sure `}<inlineCode parentName="p">{`Cartsy Helper`}</inlineCode>{` and `}<inlineCode parentName="p">{`Cartsy Algolia`}</inlineCode>{` plugin is active. If not please activate these plugins. These to plugin got deactivated when Cartsy theme is not active.`}</p>
    <h2 {...{
      "id": "google-map-doesnt-work-on-my-contact-information-page"
    }}>{`Google Map doesn't work on my contact information page?`}</h2>
    <p>{`To use google map on any page, you've to add google map key first. At first, generate a google map key from google console, and after that, insert that key on the wp-admin google maps admin panel.`}</p>
    <h2 {...{
      "id": "demo-importer-show-algolia-console-error-after-or-before-import-the-data"
    }}>{`Demo importer show Algolia console error after or before import the data?`}</h2>
    <p>{`For Cartsy, Algolia is optional and if you want to use Algolia instead of native search, then recheck if you correctly set up Algolia or not? If you're going to use a native search instead of Algolia, then deactivate the `}<inlineCode parentName="p">{`cartsy-algolia`}</inlineCode>{` plugin.`}</p>
    <h2 {...{
      "id": "how-to-resolve-multiple-search-input-boxes-on-the-homepage"
    }}>{`How to resolve multiple search input boxes on the homepage?`}</h2>
    <p>{`If you face this type of multiple search input issue `}</p>
    <p><img alt="multipleSearchInput_xjz9nh.png" src="https://res.cloudinary.com/redq-inc/image/upload/v1612851980/cartsy_doc/multipleSearchInput_xjz9nh.png" /></p>
    <p>{`Then go to `}<inlineCode parentName="p">{`Customizer -> Cartsy Theme Panel -> General`}</inlineCode>{` And define the search page. If you imported the demo and didn't change the front page, the page will be Product. `}</p>
    <p><img alt="SelectSearchPage_lvukan.png" src="https://res.cloudinary.com/redq-inc/image/upload/v1613652838/cartsy_doc/globalSearch_znerbe.png" /></p>
    <p><img alt="SearchInputOutput_in8znl.png" src="https://res.cloudinary.com/redq-inc/image/upload/v1612852201/cartsy_doc/SearchInputOutput_in8znl.png" /></p>
    <h2 {...{
      "id": "how-to-use-product-quick-view-plugin-in-the-product-grid"
    }}>{`How to use product quick view plugin in the product grid?`}</h2>
    <p>{`Currently in `}<inlineCode parentName="p">{`Chlorine`}</inlineCode>{` grid has the product quick view option only, because it's not a quick carting grid. If you want to use that plugin in other product grids, then you need to customize the grid section. For more help, you can contact with the support team.`}</p>
    <h2 {...{
      "id": "how-can-i-turn-off-cartsy-admin-notice-about-v15"
    }}>{`How can I turn off Cartsy admin notice about v1.5?`}</h2>
    <p>{`Find this action hook `}<inlineCode parentName="p">{`add_action('admin_notices', 'cartsyUpdateNotice');`}</inlineCode>{` inside the cartsy theme folder and commented it. `}</p>
    <h2 {...{
      "id": "how-can-i-create-a-extended-or-detailed-search-page-"
    }}>{`How can I create a extended or detailed search page ?`}</h2>
    <p>{`Steps 01 : Create a full width page with `}<inlineCode parentName="p">{`Extended search`}</inlineCode>{` gutenberg block.
Steps 02 : Then select that page as a search page from customizer `}<inlineCode parentName="p">{`General setting`}</inlineCode>{` `}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      